import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import Button, { default as SAIButton } from "../Base/button/Button"
import PaypalButton from "./PaypalButton"
import PaymentFirstPage from "./PaymentFirstPage"
import { saveTransaction } from "../../network/apiCalls"
import "./PaymentModal.css"

const ModalExample = props => {
  const { buttonLabel, total, currency, reportItem } = props

  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    mobile: "",
  })
  const [page, setPage] = useState(1)

  const [modal, setModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const toggle = () => {
    if (page == 1) {
      setUserDetails({
        name: "",
        email: "",
        mobile: "",
      })
      setModal(!modal)
    } else {
      setPage(1)
    }
  }

  function storePaypalTran(paymentData) {
    paymentData.name = userDetails.name
    paymentData.email = userDetails.email
    paymentData.mobile = userDetails.mobile
    saveTransaction(paymentData)
  }

  return (
    <div className="col-sm-3">
      <div onClick={toggle} style={{ cursor: "pointer" }}>
        <SAIButton text={buttonLabel} block={12} />
      </div>
      <Modal isOpen={modal} toggle={toggle} className={"modalWidth"}>
        {/* <ModalHeader toggle={toggle}>
          <div className="row">
            <div className="font-weight-light h3 m-2">
              <i className="fa fa-shopping-cart fa-2x"></i>
            </div>
            {errorMessage && (
              <div
                class="alert alert-danger alert-dismissible fade show m-2 "
                role="alert"
              >
                {errorMessage}
                <button type="button" class="close">
                  <span onClick={() => setErrorMessage(null)}>&times;</span>
                </button>
              </div>
            )}
          </div>
        </ModalHeader> */}
        <ModalBody className="p-0 m-0">
          <div className="row p-0 m-0">
            <div className="col-sm-5 bgImg p-0 m-0"></div>
            <div className="col-sm-7">
              {page == 1 ? (
                <PaymentFirstPage
                  userDetails={userDetails}
                  setUserDetails={setUserDetails}
                  setPage={setPage}
                />
              ) : (
                <>
                  <div className="bg-light p-2 m-2">
                    <div className="h4 font-weight-bold">Order Details</div>
                    <div className="text-muted h6">
                      Product Id : {reportItem.id}
                    </div>
                    <div className="text-muted h6">
                      Product Name :{" "}
                      {reportItem.title.substring(0, 100).concat("...")}
                    </div>
                    <div className="text-muted h6">
                      Publish Date : {new Date(reportItem.month).toDateString()}
                    </div>
                    <div className="text-muted h6">
                      Pages : {reportItem.pages}
                    </div>
                    <div className="text-muted h6">Total : ${total}</div>
                  </div>
                  <PaypalButton
                    currency={currency}
                    total={total}
                    setErrorMessage={setErrorMessage}
                    storePaypalTran={storePaypalTran}
                  />
                </>
              )}
              <div
                className={`row col-sm-12 ${
                  page == 2 ? "justify-content-end" : ""
                }`}
              >
                {page == 1 && (
                  <div
                    className="col-sm-6 mt-2 mb-2"
                    onClick={() => document.getElementById("payclick").click()}
                  >
                    <button className="paymentNext p-2 paymentFont">
                      NEXT
                    </button>
                  </div>
                )}
                <div
                  className="col-sm-6 float-right mt-2 mb-2"
                  onClick={toggle}
                >
                  <button className="paymentBack p-2 text-uppercase paymentFont">
                    {page == 1 ? "Cancel" : "Go Back"}
                  </button>
                </div>
              </div>
              <div className="row ml-2 paymentFont mt-2">
                <span style={{ fontSize: "14px" }}>
                  Questions? Feel free to reach out{" "}
                  <span
                    style={{ color: "#029AE9", textDecoration: "underline" }}
                  >
                    <a href="/submit-query" style={{ textDecoration: "none" }}>
                      here
                    </a>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ModalExample
